import { Injectable } from '@angular/core';
import { HttpService, PaymentgetwayService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class WalletPaymentService {

  constructor(private http: HttpService, private PAYMENT_TYPE: PaymentgetwayService) { }

  makePayment(WALLETS_INFO: any, TANX_ID: any) {
    const WALLETS_DATA = WALLETS_INFO?.wallets_banking_value;
    const PAYMENT_TYPE = this.PAYMENT_TYPE?.WalletBanking;
    const body = new URLSearchParams();
    body.set("id", TANX_ID);
    body.set("wallet[wallet_type]", WALLETS_DATA?.code)
    body.set("wallet[payOption]", PAYMENT_TYPE?.wallet_pay_Option)
    body.set("payment[payment_type]", PAYMENT_TYPE?.wallet_payment_type)
    body.set("payment[value][wallet_type]", WALLETS_DATA?.code)
    body.set("payment[value][payOption]", PAYMENT_TYPE?.wallet_pay_Option)
    body.set("is_api_payment", 'true')
    return this.http.flightsave('b2c/booking/payment', body);
  }
}
